import { useId } from 'react';
import './Select.css';

function Select({ label, error, options, children, className = '', ...props }) {
  const id = useId();
  return (
    <div className="admin-field">
      {label && <label htmlFor={id}>{label}</label>}
      <select id={id} className={`admin-select ${className}`.trim()} {...props}>
        {options
          ? options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))
          : children}
      </select>
      {error && <span className="admin-field-error">{error}</span>}
    </div>
  );
}

export default Select;
